import { Link } from 'react-router-dom';

const footerLinks = [
  { to: '/', label: '首页' },
  { to: '/category/goals', label: '进球纪录' },
  { to: '/category/national-team', label: '国家队生涯' },
  { to: '/category/dalian-shide', label: '大连实德' },
  { to: '/category/controversy', label: '争议事件' },
  { to: '/category/profile', label: '个人资料' },
  { to: '/about', label: '关于本站' },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-foreground-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <h4 className="font-heading text-xl font-bold text-background-50 mb-4">
              郝海东官方介绍站
            </h4>
            <p className="text-secondary-300 text-sm leading-relaxed">
              全面呈现中国足球传奇前锋郝海东的球员生涯、进球纪录、国家队荣耀与历史地位。致力于为球迷提供最详实、客观的郝海东资料。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              快速链接
            </h4>
            <ul className="grid grid-cols-2 gap-2">
              {footerLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-secondary-300 hover:text-background-50 text-sm transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              联系方式
            </h4>
            <p className="text-secondary-300 text-sm leading-relaxed">
              如有任何关于郝海东的资料、建议或合作意向，欢迎通过本站的联系表单与我们取得联系。
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 mt-4 px-5 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
            >
              <span>联系我们</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-700/50">
        <div className="w-full px-4 md:px-6 py-6">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-secondary-400 text-xs">
              &copy; {new Date().getFullYear()} 郝海东官方介绍站 版权所有
            </p>
            <p className="text-secondary-500 text-xs">
              本站为球迷自发整理的资料性网站，与郝海东本人无直接关联
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}